import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { ComparisonProductTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/comparisonProduct.trackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsComparisonProductImpression
    extends GoogleAnalyticsMinimumDataset {
    info: {
        action: "add" | "remove";
        products: Array<GoogleAnalyticsProduct>;
    };
}

export const getGoogleAnalyticsComparisonProductImpression = (
    data: TypedAnalyticsEvent<ComparisonProductTrackingInfo>
): GoogleAnalyticsComparisonProductImpression => {
    const googleAnalyticsProducts = data.payload.eventData.products.map(
        getGoogleAnalyticsProduct
    );

    return {
        event: GoogleAnalyticsEvents.ComparisonProduct,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            action: data.payload.eventData.action,
            products: googleAnalyticsProducts
        }
    };
};
